import React from "react";
import IssuePragatiPipelineLogo from "./../../assets/pragati-pipeline-with-shadow.svg";

function AgendaIssuePragatiPipeline({
  className,
  isPragatiPipeline,
  isAgendaDetail = false,
  statepmguser
}) {
  return isPragatiPipeline ? (
    <div
      className={isAgendaDetail ? className : className}
      style={{ marginTop: statepmguser ? "0px" : "-30px" }}
    >
      <img alt="issuePragatiPipeline" src={IssuePragatiPipelineLogo} />
    </div>
  ) : null;
}

export default AgendaIssuePragatiPipeline;
